module.exports = __webpack_public_path__ + "assets/images/USDNEW1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/USDNEW1.png
// module id = 1458
// module chunks = 1